import React from "react";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";

const linearSx = {
  height: 8,
  borderRadius: 4,
  backgroundColor: "var(--theme-btn-clr)",
  "& .MuiLinearProgress-bar": {
    backgroundColor: "var(--theme-color)",
  },
};

/**
 * Determinate upload bar for XHR multipart submissions (legacy panel + wizard).
 * Hidden when progress is 0.
 */
function SubmissionUploadProgress({ progress }) {
  if (!progress || progress <= 0) {
    return null;
  }

  return (
    <Box sx={{ margin: "20px 0" }}>
      <LinearProgress variant="determinate" value={progress} sx={linearSx} />
      <Typography variant="body2" sx={{ mt: 0.75, color: "var(--theme-color)" }}>
        Uploading: {progress}%
      </Typography>
    </Box>
  );
}

export default React.memo(SubmissionUploadProgress);
